module.exports = __webpack_public_path__ + "static/media/pc.82902e49.png";